import { DATA_GIF_PATH } from "../../utils/config";
import GxBlackButtonSmall from "../../components/common/actions/buttons/GxBlackButtonSmall";

interface BeneSuccessModalProps {
  readonly onClose: () => void;
  readonly isOpen: boolean;
  readonly successData: {
    readonly aprdStatus: "A" | "R" | "D" | "PD" | "SR";
    readonly beneName?: string | null;
  };
}

export default function BeneSuccessModal({
  isOpen,
  onClose,
  successData,
}: BeneSuccessModalProps) {
  if (!isOpen) return null;

  const hasBeneName =
    Boolean(successData?.beneName) && successData.beneName!.trim() !== "";

  const getTitle = () => {
    switch (successData?.aprdStatus) {
      case "A":
        return "Beneficiary Approved!";
      case "R":
        return "Beneficiary Rejected";
      case "D":
        return "Beneficiary Deleted";
      case "PD":
        return "Payer Deleted";
      default:
        return "Status Unknown";
    }
  };

  const getDescription = () => {
    switch (successData?.aprdStatus) {
      case "A":
        return hasBeneName
          ? `The beneficiary "${successData.beneName}" has been successfully approved.`
          : `The beneficiary has been successfully approved.`;

      case "R":
        return hasBeneName
          ? `The beneficiary "${successData.beneName}" has been rejected. Please check details for necessary corrections.`
          : `The beneficiary has been rejected. Please check details for necessary corrections.`;

      case "D":
        return hasBeneName
          ? `The beneficiary "${successData.beneName}" has been deleted.`
          : `The beneficiary has been deleted.`;

      case "PD":
        return hasBeneName
          ? `The payer "${successData.beneName}" has been deleted.`
          : `The payer has been deleted.`;

      default:
        return "-";
    }
  };

  const getGif = () => {
    switch (successData?.aprdStatus) {
      case "A":
        return `${DATA_GIF_PATH}done_animation.gif`;
      case "R":
        return `${DATA_GIF_PATH}done_animation.gif`; // reject_animation --> I changed this icon, Like, If reject "R"? showing done_animation gif
      case "D":
        return `${DATA_GIF_PATH}done_animation.gif`;
      case "PD":
        return `${DATA_GIF_PATH}done_animation.gif`;
      default:
        return `${DATA_GIF_PATH}default_animation.gif`;
    }
  };

  return (
    <div className="gx-custom-remark-modal-background-t">
      <div className="gx-custom-remark-modal-conatiner">
        <div className={`gx-custom-remark-modal ${isOpen ? "show" : "hide"}`}>
          <main className="gx-custom-remark-modal-main">
            <div className="gx-animation-wrapper-s">
              <img
                src={getGif()}
                alt="Status"
                className="gx-success-animation"
              />
            </div>
            <div className="flex justify-center">
              <span className="gx-message gx-font-regular">{getTitle()}</span>
            </div>
            <div className="mt-4 flex justify-center">
              <p className="text-[#4d4d4d] text-[0.75rem] gx-font-medium text-center">
                {getDescription()}
              </p>
            </div>
          </main>
          <footer className="gx-custom-remark-modal-footer">
            <div className="space-x-4">
              <GxBlackButtonSmall onClick={onClose}>Close</GxBlackButtonSmall>
            </div>
          </footer>
        </div>
      </div>
    </div>
  );
}
